/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-10-13 16:44:07
 */
import { defineMessages } from 'react-intl';

const messageObject: { [propName: string]: string } = {
  platformManage: '平台管理',
  serviceManage: '服务管理',
  systemApplicationManagement: '系统应用管理',
  start: '启动',
  stop: '停止',
  restart: '重启',
  baseMsg: '基本信息',
  alarmThreshold: '告警阈值',
  alarmThresholdConfig: '告警阈值设置',
  suposVersion: 'supOS版本',
  installMenu: '安装目录',
  dockerVersion: 'Docker版本',
  memory: '总内存',
  disk: '磁盘',
  systemTime: '系统时间',
  networkCard: '网卡管理',
  name: '名称',
  address: '地址',
  gateway: '网关',
  sending: '接收中',
  receiving: '接收中',
  operate: '操作',
  edit: '修改',
  cpuNull: '请输入CPU',
  memoryNull: '请输入总内存',
  diskNull: '请输入磁盘',
  serviceAlreadyRunning: '已运行服务:',
  serviceName: '服务名称',
  status: '状态',
  namespace: '命名空间',
  startTime: '部署时间',
  cpuLimit: 'CPU限制值',
  cpuCurrent: 'CPU当前值',
  cpuUsage: 'CPU使用率',
  memLimit: '内存限制值',
  memCurrent: '内存当前值',
  memUsage: '内存使用率',
  storageLimit: '磁盘限制值',
  storageCurrent: '磁盘当前值',
  storageUsage: '磁盘使用率',
  alertEnabled: '告警开启',
  stopServices: '请确认停止该服务？',
  restartServices: '请确认重启该服务？',
  closeServices: '请确认关闭该服务报警？',
  startServices: '请确认启动该服务？',
  action: '操作',
  all: '全部',
  resourceAllocation: '资源配置',
  alarmSetting: '告警设置',
  beginTime: '开始时间1',
  duration: '持续时间',
  durationNull: '请输入持续时间',
  notInstall: '未安装',
  running: '运行中',
  starting: '启动中',
  restarting: '重启中...',
  stopped: '已停止',
  pending: '启动中...',
  runNing: '正在运行',
  stopping: '停止中...',
  installing: '安装中',
  upgrading: '升级中',
  uninstalling: '卸载中',
  notinstall: '未安装',
  paused: '已暂停',
  run_with_high_risk: '运行中',
  run_with_low_risk: '运行中',
  lowRisk: '低风险',
  highHisk: '高风险',
  stopConfirm: '确定停止supOS吗',
  restartConfirm: '确定重启supOS吗?',
  startConfirm: '确定启动supOS吗?',
  closeConfirm: '确定取消设置吗？',
  closeAlarm: '确认关闭该服务告警?',
  platformConfig: '平台配置',
  availableCPU: '可用CPU',
  availableMemory: '可用内存',
  port: '访问端口',
  portNull: '请输入访问端口',
  editPlatformConfig: '编辑平台配置',
  reservedPortError: '该端口为保留端口',
  portError: '请输入正确端口',
  memoryMaxError: '内存不能大于',
  memoryMinError: '内存不能小于27G',
  cpuMaxError: 'CPU不能大于',
  cpuMinError: 'CPU不能小于13vC',
  confirmTip: '如有缩小平台资源，可能会造成重启supOS后，部分服务无法启动。请确认修改？',
  updating: '正在更新配置',
  success: '设置成功',
  stopTip: '停止后，supOS将无法使用，请确认？',
  restartTip: '重启supOS需要较长时间，请确认',
  jvmLimit: '堆内存',
  jvmNull: '请输入堆内存',
  sourceConfigSet: '配置资源限值',
  open: '开启',
  close: '关闭',
  decimalError: '值只能是整数',
  sourceConfigTip:
    '修改配置会重启相应的服务，相关功能重启期间不可用;环境变量不正确会导致服务无法启动，请确认所填写的环境变量是否正确',
  systemVersion: '系统版本',
  reFreshTime: '刷新时间:10s',
  pleaseStopSupos: '请先停止supOS',
  editDateTip: '启动中、停止中、重启中和更新中不能修改系统时间',
  waiting: '等待中',
  appName: '应用名称',
  field: '所属领域',
  runningState: '运行状态',
  podQuantity: 'Pod数量',
  podName: 'Pod名称',
  dependenciesStatusOK: '所有依赖项，正常',
  dependenciesStatusTip: '依赖的 {dependencies} 应用异常',
  podStateList: 'Pod状态列表',
  confirm: '确认',
  application: '所属应用',
  VIEW_STARTING: '启动中',
  VIEW_RUNNING: '运行中',
  VIEW_STOPPED: '停止中',
  supOSRequired: 'supOS运行必须',
  required: '是否必须',
  yes: '是',
  no: '否',
  serialNo: '序号',
};

export default defineMessages(messageObject);
